/**
 * Shared WebRTC Player configuration options
 */

export interface WebRTCPlayerBaseOptions {
  debug: boolean;
  videoDisabled: boolean;
  authTokenName: string;
  tokenValue: string;
  whipwhap: boolean;
  statsSendEnable: boolean;
  trackStats: boolean;
  iceServers: { urls: string }[];
  shouldLog: boolean;
}

/**
 * Get base WebRTC player options
 * @param whipwhapEnabled - Whether to enable whipwhap protocol
 * @returns Base configuration options for Flussonic WebRTC Player
 */
export const getWebRTCPlayerBaseOptions = (
  whipwhapEnabled: boolean
): WebRTCPlayerBaseOptions => {
  return {
    debug: true,
    videoDisabled: true,
    authTokenName: "token",
    tokenValue: "SentanaECB",
    whipwhap: whipwhapEnabled,
    statsSendEnable: false,
    trackStats: false,
    iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
    shouldLog: true,
  };
};

/**
 * Read whipwhap setting from environment variable
 * Defaults to true if not set or set to any value other than "false"
 * @returns Whether whipwhap should be enabled
 */
export const isWhipwhapEnabled = (): boolean => {
  return import.meta.env.VITE_WHIPWHAP_ENABLED === "true";
};
